import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as i, openBlock as r, normalizeClass as d, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const n = {
  name: "DtIconHashBold",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ o("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.068 1.396a.938.938 0 0 1 1.864.207l-.218 1.96h1.114l.24-2.167a.938.938 0 0 1 1.864.207l-.218 1.96H10a.937.937 0 1 1 0 1.874H8.506L8.38 6.562H10a.937.937 0 1 1 0 1.875H8.172l-.24 2.167a.937.937 0 1 1-1.864-.208l.218-1.959H5.172l-.24 2.167a.937.937 0 1 1-1.864-.208l.218-1.959H2a.937.937 0 1 1 0-1.875h1.494l.125-1.125H2a.937.937 0 1 1 0-1.875h1.828l.24-2.166ZM4.715 4.3a.501.501 0 0 1-.253.226.5.5 0 0 1 .156.174.501.501 0 0 1 .253-.226.5.5 0 0 1-.156-.174Zm2.747.226a.5.5 0 0 1 .156.174.501.501 0 0 1 .253-.226.5.5 0 0 1-.156-.174.501.501 0 0 1-.253.226ZM7.382 7.3a.501.501 0 0 1-.253.226.5.5 0 0 1 .156.174.501.501 0 0 1 .253-.226.5.5 0 0 1-.156-.174Zm-2.844.174a.5.5 0 0 1-.156-.174.501.501 0 0 1-.253.226.5.5 0 0 1 .156.174.501.501 0 0 1 .253-.226Zm.968-2.037L5.38 6.562h1.113l.125-1.125H5.506Z",
  fill: "currentColor"
}, null, -1), h = [
  _
];
function m(e, u, l, f, p, a) {
  return r(), i("svg", {
    "aria-label": l.ariaLabel,
    class: d([a.iconSizeClass, "d-icon d-icon--hash-bold"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Hash Bold",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, h, 10, c);
}
const v = /* @__PURE__ */ s(n, [["render", m]]);
export {
  v as default
};
//# sourceMappingURL=hash-bold.js.map
